import { Flex } from '../../../summary/components/Flex.tsx';
import { Typography } from '../../../summary/components/Typography.tsx';
import { SummarySection } from '../SummarySection.tsx';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { AdjustmentBreakdownDepreciatedCostAdditionalImprovements } from './AdjustmentBreakdownDepreciatedCostAdditionalImprovements/AdjustmentBreakdownDepreciatedCostAdditionalImprovements.tsx';
import { AdjustmentBreakdownDepreciatedCostMainDwelling } from './AdjustmentBreakdownDepreciatedCostMainDwelling.tsx';

export const AdjustmentBreakdownDepreciatedCostAdjustments = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => (
  <SummarySection>
    <TitleAndExportToggleLockup
      {...props}
      title="Depreciated Cost Adjustments"
      id="isDepreciatedCostAdjustmentsInExport"
      variant="h1"
    />
    <Flex marginBottom="2rem">
      <Typography variant="body1">
        Depreciated cost was used to determine the value of improvements for the subject and
        comparables (cost provider: DwellingCost.com). Adjustments are based on the difference
        between the subject’s depreciated cost and each comparable’s depreciated cost for each
        improvement (main dwelling, garage/carport, etc).
      </Typography>
    </Flex>
    <AdjustmentBreakdownDepreciatedCostMainDwelling {...props} />
    <AdjustmentBreakdownDepreciatedCostAdditionalImprovements {...props} />
  </SummarySection>
);
